import { nullable, number, string, struct } from 'io-ts/Decoder';

import { Id as Level } from '../../../../ai/floor-level/Id';
import { Id as TransactionId } from '../../../../transaction/Id';
import { Area } from '../../../../ui/geometry/Area';
import { ScalePath } from '../../../../whole-house/scale';

export const Request = struct({
	transactionId: TransactionId,
	pageId: string,
	name: string,
	level: nullable(Level),
	area: Area,
	scale: number,
	scalePath: ScalePath,
});
